module.exports = __webpack_public_path__ + "img/112.3.ce0ce704.png";